import { apiSlice } from "../../app/api/apiSlice";

export const getEligibleProductsSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getEligibleProducts: builder.mutation({
			query: (credentials) => ({
				url: "api/v1/loan/get_ob_eligible_products/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useGetEligibleProductsMutation } = getEligibleProductsSlice;
